import { CaseProgress } from '@/contexts/MasterclassContext';

import { CaseConfig } from './types/generated';

/**
 * Get the slide index to resume from based on session progress.
 *
 * @param caseContent - The case configuration with slides
 * @param sessionProgress - Map of session progress keyed by masterclassId
 * @param masterclassId - The masterclass ID (sessions are per-masterclass, not per-case)
 * @returns The slide index to start from (0 if no progress)
 */
export function getCaseSlideIndexFromProgress(
  caseContent: CaseConfig | null,
  sessionProgress: Record<string, CaseProgress>,
  masterclassId: string | null
): number {
  if (!caseContent || !masterclassId) return 0;
  const progress = sessionProgress[masterclassId];
  if (!progress) return 0;

  const currentSlideId = progress.currentSlideId;
  if (!currentSlideId) return 0;

  const slideIndex = caseContent.slides.findIndex((slide) => slide.id === currentSlideId);
  return slideIndex >= 0 ? slideIndex : 0;
}
